import { makeStyles } from "@material-ui/styles";

const individualStatsStyles = makeStyles(() => ({
	sectionTitle: {
		padding: "10px 0"
	},
	individualTeamStats: {
		"& th": {
			textTransform: "uppercase"
		}
	},
	tableHeader: {
		fontWeight: "bold"
	}
}));

export default individualStatsStyles;
